import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioButtonCheckedRoundedIcon from "@material-ui/icons/RadioButtonCheckedRounded";
import RadioButtonUncheckedRoundedIcon from "@material-ui/icons/RadioButtonUncheckedRounded";
import Switch from "@material-ui/core/Switch";
import { vars } from "../../../config/theme";
import TextField from "@material-ui/core/TextField";

export const booleanRenderer = (
    value,
    name,
    editable,
    fieldUpdateHandler,
    isError,
    mutable,
    setUpdateRates,
    readOnly = false, // Добавляем новый параметр
) => {
    // Режим только для чтения
    if (readOnly) {
        return (
            <FormControlLabel
                control={
                    <Switch color="primary" checked={!!value} disabled={true} />
                }
            />
        );
    }

    // Оригинальная логика
    return editable || typeof fieldUpdateHandler === "function" ? (
        <FormControlLabel
            control={
                <>
                    <Switch
                        color="primary"
                        checked={!!value}
                        onChange={(e) => {
                            fieldUpdateHandler(name, !value);
                            if (
                                name === "inherited" &&
                                typeof setUpdateRates === "function"
                            ) {
                                setUpdateRates((pr) => !pr);
                            }
                        }}
                        disabled={
                            !mutable || (editable !== undefined && !editable)
                        }
                    />
                    {isError && (
                        <TextField error={!!isError} helperText={isError} />
                    )}
                </>
            }
        />
    ) : value ? (
        <RadioButtonCheckedRoundedIcon style={{ color: vars.active }} />
    ) : (
        <RadioButtonUncheckedRoundedIcon style={{ color: vars.inactive }} />
    );
};
